import axios from 'axios';
import { getToken } from '../utils/auth';

const api = axios.create({
  baseURL: process.env.REACT_APP_API_URL || 'http://localhost:5000/api'
});

api.interceptors.request.use((config) => {
  const token = getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

export const authAPI = {
  login: (credentials) => api.post('/auth/login', credentials),
  register: (credentials) => api.post('/auth/register', credentials),
  oauthLogin: (provider, code) => api.post(`/auth/oauth/${provider}`, { code })
};

export const buildAPI = {
  trigger: (data) => api.post('/builds/trigger', data),
  getStatus: (buildId) => api.get(`/builds/${buildId}`),
  getLogs: (buildId) => api.get(`/builds/${buildId}/logs`),
  getHistory: () => api.get('/builds/history')
};

export const repoAPI = {
  list: (provider) => api.get(`/repos/${provider}`)
};

export default api;
